import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import useUsers from "containers/user-management/useHooks";
import { useEffect, useState } from "react";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import { AmbassadorIocn } from "assets/images/common/svgs";

import { sitePermissions } from "utils/helpers/enums/permissions.enum";
import useStore from "hooks/useStore";


const AmbassadorRequest = () => {
  const { hasPermission } = useStore();
  const navigate = useNavigate();
  const location = useLocation();
  const { approveRequest } = useUsers();
  const { getUser } = useStore();
  const userData = getUser();
  console.log(userData, "userData");
  const { allData, selectedUserId } = location.state || {};
  const selectedUser = allData?.find((user: any) => user.id === selectedUserId);
  useEffect(() => {
    if (!selectedUserId || !selectedUser) {
      navigate(-1);
      return;
    }
  }, [selectedUserId, selectedUser]);

  const goToBack = () => {
    navigate(-1);
  };

  const handleApprove = () => {
    if (!selectedUserId) return;
    approveRequest(selectedUserId, { isApproved: true });
  };

  const handleReject = async () => {
    if (!selectedUserId) return;
    approveRequest(selectedUserId, { isApproved: false });
  };

  console.log(selectedUser, "allData");


  return (
    <div className="pb-5">
      <div className="flex justify-between items-center gap-4 ">
        <h1 className="text-base text-primaryText font-bold mb-6 flex items-center gap-3">
          <span
            onClick={goToBack}
            className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
          >
            <ArrowBackIcon />
          </span>
          {/* {tabTitle} */} Ambassador Detail
        </h1>
      </div>

      <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-lg p-8">
        <div className="">
          <img className="w-[132px] h-[132px] rounded-full" src={
            selectedUser?.profilePic
              ? concatPathWithBackendUrl(
                selectedUser?.profilePic?.name
              )
              : editProfilePicUser
          } />
        </div>
        <div className="my-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-8">
          <div className="flex flex-col gap-4">
            <span className="text-sm font-semibold text-captionText">
              First Name
            </span>
            <span className="text-xs text-tertiaryText">  {selectedUser?.firstName || "-"}</span>
          </div>
          <div className="flex flex-col gap-4">
            <span className="text-sm font-semibold text-captionText">
              Last Name
            </span>
            <span className="text-xs text-tertiaryText">  {selectedUser?.lastName || "-"}</span>
          </div>
          <div className="flex flex-col gap-4">
            <span className="text-sm font-semibold text-captionText">
              Date of Birth
            </span>
            <span className="text-xs text-tertiaryText">{selectedUser?.dob || "-"}</span>
          </div>
          <div className="flex flex-col gap-4">
            <span className="text-sm font-semibold text-captionText">
              Email
            </span>
            <span className="text-xs text-tertiaryText">
              {selectedUser?.email || "-"}
            </span>
          </div>
          <div className="flex flex-col gap-4">
            <span className="text-sm font-semibold text-captionText">
              Gender
            </span>
            <span className="text-xs text-tertiaryText">{selectedUser?.gender || "-"}</span>
          </div>
          <div className="flex flex-col gap-4">
            <span className="text-sm font-semibold text-captionText">
              Phone Number
            </span>
            <span className="text-xs text-tertiaryText">{selectedUser?.phone || "-"}</span>
          </div>
          <div className="flex flex-col gap-4">
            <span className="text-sm font-semibold text-captionText">
              Physical Address
            </span>
            <span className="text-xs text-tertiaryText">
              {selectedUser?.address || "-"}
            </span>
          </div>
          <div className="flex flex-col gap-4">
            <span className="text-sm font-semibold text-captionText">
              Languages
            </span>
            <div className="flex flex-wrap gap-2">
              <span className="text-xs bg-gray-200 px-2 py-1 rounded">
                {selectedUser?.language || "-"}
              </span>
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <span className="text-sm font-semibold text-captionText">City</span>
            <span className="text-xs text-tertiaryText"> {selectedUser?.city || "-"}</span>
          </div>
          <div className="flex flex-col gap-4">
            <span className="text-sm font-semibold text-captionText">
              State
            </span>
            <span className="text-xs text-tertiaryText">{selectedUser?.state || "-"}</span>
          </div>
          <div className="flex flex-col gap-4">
            <span className="text-sm font-semibold text-captionText">
              Zip Code
            </span>
            <span className="text-xs text-tertiaryText">{selectedUser?.zipCode || "-"}</span>
          </div>
          <div className="flex flex-col gap-4">
            <span className="text-sm font-semibold text-captionText">
              Member Since
            </span>
            <span className="text-xs text-tertiaryText">  {selectedUser?.ambassador?.createdAt
              ? new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              }).format(new Date(selectedUser?.ambassador?.createdAt))
              : "-"}</span>
          </div>


        </div>
        {
          <div className="my-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-8">
            <div className="flex flex-col gap-4">
              <span className="text-sm font-semibold text-captionText">Meeting Link</span>
              {selectedUser?.bookedSession?.meetingLink ? (
                <a 
                  href={selectedUser.bookedSession.meetingLink} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-xs text-blue-600 hover:text-blue-800 underline break-all"
                >
                  {selectedUser.bookedSession.meetingLink}
                </a>
              ) : (
                <span className="text-xs text-tertiaryText">-</span>
              )}
            </div>
            <div className="flex flex-col gap-4">
              <span className="text-sm font-semibold text-captionText">
                Start Date
              </span>
              <span className="text-xs text-tertiaryText">
                {selectedUser?.bookedSession?.startTime 
                  ? new Intl.DateTimeFormat("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true
                    }).format(new Date(selectedUser.bookedSession.startTime))
                  : "-"
                }
              </span>
            </div>
            <div className="flex flex-col gap-4">
              <span className="text-sm font-semibold text-captionText">
                End Date
              </span>
              <span className="text-xs text-tertiaryText">
                {selectedUser?.bookedSession?.endTime 
                  ? new Intl.DateTimeFormat("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true
                    }).format(new Date(selectedUser.bookedSession.endTime))
                  : "-"
                }
              </span>
            </div>
          </div>

        }

        <div className="flex items-center gap-4 flex-wrap ">

          {selectedUser?.ambassador?.bookedSessionType !== null && (
            (userData?.roles?.includes("SUPER_ADMIN") || 
             userData?.roles?.includes("COO") || 
             selectedUser?.bookedSession?.teamMemberId === userData?.id) && (
              <>
                <button onClick={handleApprove} className="w-[95px] h-[35px] text-xs rounded-[8px] text-white bg-greenBg">
                  Approve
                </button>
                <button onClick={handleReject} className="w-[95px] h-[35px] text-xs rounded-[8px] text-white bg-redLightBg">
                  Dismiss
                </button>
              </>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default AmbassadorRequest;
